<template><SimpleModuleDashboard :module-id="Modules.WHATSAPP_MARKETING" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'crudLists', reference: 'crudLists', route: 'WhatsappMarketingStaffCrudLists', tone: 'primary' },
  { id: 'crudContact', reference: 'crudContact', route: 'WhatsappMarketingStaffCrudContact', tone: 'primary' },
  { id: 'crudMessage', reference: 'crudMessage', route: 'WhatsappMarketingStaffCrudMessage', tone: 'primary' },
  { id: 'crudConversations', reference: 'crudConversations', route: 'WhatsappMarketingStaffCrudConversations', tone: 'primary' },
  { id: 'crudSettings', reference: 'crudSettings', route: 'WhatsappMarketingStaffCrudSettings', tone: 'primary' },
] }) }
</script>
